import ConsultaBase from "../shared/ConsultaBase";
import { fullServiceCoolingV3_1CompConsultaConfig } from "../config/fullServiceCoolingV3_1CompConsulta";

const CFSCV31Comp = () => {
  return <ConsultaBase config={fullServiceCoolingV3_1CompConsultaConfig} />;
};

export default CFSCV31Comp;